import {createContext, useContext} from 'react';

const ModalContext = createContext(undefined);

function ModelProvider({children, value}) {
  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  )
}

function useModelContext() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useCounterContext 必須在 CounterProvider 中使用');
  }
  return context;
}

export { ModelProvider, useModelContext };

export default ModelProvider;

